import { Route, Routes } from 'react-router';
import {
  ProfileHomePage,
  ProfileClinicalDataPage,
  ProfileClinicalDataFormPage
} from '#pages';
import ClinicalData from '#providers/ClinicalData';
import CoachLecture from '#providers/CoachLecture';
import { Container } from './styles';

import LectureEditForm from 'src/refactor_page/lecture-edit';
import ScheduleEdit from 'src/refactor_page/schedule-edit';
import Qualification from 'src/refactor_page/qualification';
import GymList from 'src/refactor_page/gym-list';
import GymEdit from 'src/refactor_page/gym-edit';
import GymAdd from 'src/refactor_page/gym-add';

import ActivitiesList from 'src/refactor_page/activties/list';
import { IntroEdit } from 'src/refactor_page/introduce-edit';
import { ProfileEdit } from 'src/refactor_page/profile-edit';
import { Portfolio } from 'src/refactor_page/portfolio/register';

/**
 * @author sky.blue
 * @description 해당 페이지는 프로필 관련 페이지입니다.
 * 초기에는 코치프로필만 존재하므로 해당 페이지는 코치 기준으로 구현됩니다.
 */
export function ProfileView() {
  return (
    <Container>
      <Routes>
        <Route path="" element={<ProfileHomePage />} />
        {/* <Route path="update" element={<ProfileUpdate />} /> */}
        {/* <Route path="my-url" element={<MyPageMyUrl />} /> */}
        {/* <Route path="top" element={<MyPageTopAuthentication />} /> */}
        <Route path="schedule" element={<ScheduleEdit />} />
        <Route path="introduce" element={<IntroEdit />} />
        <Route path="profile-edit" element={<ProfileEdit />} />
        {/* 신규 페이지 gym */}
        <Route
          path="gym/*"
          element={
            <Routes>
              <Route path="" element={<GymList />} />
              <Route path="add" element={<GymEdit />} />
              <Route path="register" element={<GymAdd />} />
            </Routes>
          }
        />
        <Route
          path="activities/*"
          element={
            <Routes>
              <Route path=":id" element={<ActivitiesList />} />
            </Routes>
          }
        />

        <Route
          path="class/*"
          element={
            <CoachLecture>
              <Routes>
                <Route path="register" element={<LectureEditForm />} />
                <Route path="/:id" element={<LectureEditForm />} />
                {/* <Route path="price" element={<ProfileClassPricePage />} /> */}
              </Routes>
            </CoachLecture>
          }
        />
        <Route path="qualification/:id" element={<Qualification />} />

        {/* <Route path="category" element={<ProfileCategoryPage />} /> */}
        <Route
          path="portfolio/*"
          element={
            <ClinicalData>
              <Routes>
                <Route index element={<ProfileClinicalDataPage />} />
                <Route path="register" element={<Portfolio />} />
                <Route path="edit/:id" element={<Portfolio />} />
              </Routes>
            </ClinicalData>
          }
        />
      </Routes>
    </Container>
  );
}
